import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=5963b6f3&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=5963b6f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5963b6f3",
  null
  
)

export default component.exports